module.exports = __webpack_public_path__ + "static/media/yunying5.13727226.jpg";